import React, { useEffect, useState } from "react";
import configData from "../config.json";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MultiAppBar from "../components/multi_components/MultiAppBar";
import MultiAuthentication from "../components/multi_components/MultiAuthentication";
import { CircularProgress } from "@mui/material";
import RealTimeRow from "../components/multi_components/RealTimeRow";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReconnectingEventSource from "reconnecting-eventsource";
import { useNavigate, useParams } from "react-router-dom";
import { getToken } from "../utils/auth"

function MultiRealTime() {
  const params = useParams();
  const navigate = useNavigate();
  const [hasToken, setHasToken] = useState(true);
  const [token, setToken] = useState("");
  const [notifications, setNotifications] = useState([]);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const [selectedTablets, setSelectedTablets] = useState(null);

  // useEffect(() => {
  //   if (selectedTablets) {
  //     const token = getToken()
  //     const sse = new ReconnectingEventSource(
  //       `${configData.SERVER_URL
  //       }/stream/multi/updates?token=${encodeURIComponent(token)}`
  //     );

  //     const handleStream = (data) => {
  //       const a = JSON.parse(data.data);
  //       const newMessage = `${a.serial_number} ${a.message}`;
  //       const index = selectedTablets.findIndex(
  //         (obj) => obj.serial_number === a.serial_number
  //       );
  //       if (index !== -1) {
  //         notify(newMessage, "success");
  //         setNotifications((prevstate) => [...prevstate, a]);

  //         if (a.message === "Config result arrived") {
  //           selectedTablets[index].config = a.config;
  //         }
  //       } else {
  //         console.log(
  //           `Serial number ${a.serial_number} was not found in the list`
  //         );
  //       }
  //     };

  //     sse.onopen = (e) => {
  //       console.log("connection opened");
  //     };

  //     sse.onmessage = (e) => {
  //       handleStream(e);
  //       console.log("got message: ", e);
  //     };

  //     sse.onerror = (e) => {
  //       console.log("got error:", e);
  //       sse.close();

  //       // setTimeout(() => {
  //       //   console.log("reconnecting...");
  //       //   sse._start();
  //       // }, 5000);
  //     };

  //     sse.onclose = (e) => {
  //       console.log("connection closed, attempting to reconnect...");
  //       sse.open();
  //     };

  //     window.addEventListener("beforeunload", () => {
  //       sse.close();
  //     });

  //     return () => {
  //       sse.close();
  //     };
  //   }
  // }, [selectedTablets, hasToken]);

  //selected tablets data

  //selected tablets data fetch
  useEffect(() => {
    const servertoken = getToken()
    let serial_string = atob(params.serials);
    let serial_list = JSON.parse(serial_string);
    let newBody = {
      serial_numbers: serial_list,
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/RT/Selected`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": servertoken,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setSelectedTablets(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          setTimeout(() => {
            navigate("/");
          }, 10000); // 10000 ms = 10 seconds
        } else {
          if (error.message === "403") {
            navigate("/");
          } else {
            notify(error, "error");
          }
        }
      });
  }, [hasToken]);

  useEffect(() => {
    const checkToken = () => {
      const cookie = document.cookie;
      const token = cookie.split("; ").find((row) => row.startsWith("token="));

      if (token) {
        setHasToken(true);
        setToken(token.split("=")[1]);
        console.log("token found");
      } else {
        setHasToken(false);
        setToken("");
      }
    };

    checkToken();
  }, [hasToken]);
  const handleNewToken = (newToken) => {
    console.log("updating the new token");
    if (newToken !== hasToken) {
      setHasToken(!hasToken);
    }
  };
  return (
    <>
      {token === "" ? (
        <MultiAuthentication handleNewToken={handleNewToken} />
      ) : (
        <div className="container">
          {selectedTablets ? (
            <>
              {" "}
              <MultiAppBar
                tablets={selectedTablets}
                hasToken={hasToken}
                handleNewToken={handleNewToken}
              />
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>Serial Number</strong>
                      </TableCell>
                      <TableCell align="left">
                        <strong>Screenshot</strong>
                      </TableCell>
                      <TableCell align="left">
                        <strong>Shopping List</strong>
                      </TableCell>
                      <TableCell align="left">
                        <strong>Searched</strong>
                      </TableCell>
                      <TableCell align="left">
                        <strong>QR List</strong>
                      </TableCell>
                      <TableCell align="left">
                        <strong>Config</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedTablets.map((row) => (
                      <RealTimeRow
                        row={row}
                        key={row.serial_number}
                        config={row.config}
                        hasToken={hasToken}
                        handleNewToken={handleNewToken}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <div style={{ textAlign: "center", height: "50vh" }}>
              <br />
              <br />
              <br />
              <br />
              <CircularProgress size={72} />
            </div>
          )}
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      )}
    </>
  );
}

export default MultiRealTime;
